import styled from 'styled-components'
import { TEXT_STYLES } from 'constants/text_styles'

const ContentCellContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const ContentCellTitle = styled.div`
  ${TEXT_STYLES.TableBody}
  font-size: 12px !important;
  font-weight: ${props =>
    props.variant === 'light' ? '400' : '500'} !important;
  line-height: 1.5 !important;
`

const ContentCellSubtitle = styled.div`
  ${TEXT_STYLES.BodyInactive}
  font-size: 11px !important;
`

export const ContentCell = ContentCellContainer
ContentCell.Title = ContentCellTitle
ContentCell.Subtitle = ContentCellSubtitle
